import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "./HomePage";
import { LiveBadge } from "../components/Layout";

export default function CampaignPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/campaigns/${id}`).then(({data}) => setData(data));
  }, [id]);

  if (!data) return <div className="p-10 text-center text-[#A1A1AA]">Loading…</div>;
  const c = data.campaign;

  return (
    <div className="pb-24 md:pb-12">
      <div className="relative h-64 sm:h-80">
        <img src={c.banner_url} className="w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-t from-black to-black/40"/>
        <div className="absolute inset-0 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-8">
          <div className="inline-flex self-start bg-[#FF007F] text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-3">
            Campaign · -{c.offer_percent}% OFF
          </div>
          <h1 className="font-display font-black text-4xl sm:text-6xl uppercase tracking-tight">{c.title}</h1>
          <p className="text-[#A1A1AA] mt-2 max-w-xl">{c.description}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 space-y-10">
        {data.streams?.length > 0 && (
          <section>
            <h2 className="font-display text-2xl font-bold uppercase mb-3">Live during campaign<span className="text-[#FF007F]">.</span></h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {data.streams.map(s => (
                <Link key={s.stream_id} to={`/live/${s.stream_id}`} className="card relative block">
                  <div className="aspect-video"><img src={s.thumbnail_url} className="w-full h-full object-cover"/></div>
                  {s.is_live && <div className="absolute top-2 left-2"><LiveBadge/></div>}
                  <div className="p-3 text-sm font-bold">{s.title}</div>
                </Link>
              ))}
            </div>
          </section>
        )}
        <section>
          <h2 className="font-display text-2xl font-bold uppercase mb-3">Products in this drop</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {data.products.map((p, i) => <ProductCard key={p.product_id} p={p} index={i}/>)}
          </div>
        </section>
      </div>
    </div>
  );
}
